import { Crown } from "lucide-react";

export const Brand = ({ size = "md" }) => (
  <div className="flex items-center gap-3" data-testid="brand-logo">
    <img
      src="/images/brand-crest.png"
      alt="Luxury Elite ATL"
      className={`${size === "lg" ? "h-14 w-14" : "h-10 w-10"} object-contain`}
    />
    <div className="leading-none">
      <div className={`font-display tracking-tight text-ivory ${size === "lg" ? "text-2xl" : "text-lg"}`}>
        Luxury Elite
      </div>
      <div className="mt-1 text-[9px] font-medium uppercase tracking-[0.3em] text-gold">Executive Transportation</div>
    </div>
  </div>
);

export const TierPill = ({ tier, testId = "membership-tier" }) => (
  <span
    data-testid={testId}
    className="inline-flex items-center gap-1.5 rounded-full border border-gold/30 bg-gold/10 px-3 py-1 text-[11px] font-medium uppercase tracking-[0.18em] text-gold"
  >
    <Crown className="h-3.5 w-3.5" strokeWidth={1.8} />
    {tier}
  </span>
);
